'use client';

import { usePathname } from 'next/navigation';
import { ReactNode } from 'react';

// Routes that manage their own full-page layout (no sidebar offset, no nav padding)
const FULL_PAGE_ROUTES = ['/', '/onboarding', '/philosophy', '/admin/community-plants', '/admin/community-pests'];

export default function MainWrapper({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const isFullPage = FULL_PAGE_ROUTES.includes(pathname);

  if (isFullPage) {
    return <>{children}</>;
  }

  return (
    <main className="md:ml-[260px] min-h-screen pt-[68px] pr-5 pb-[80px] pl-5 md:p-8">
      {children}
    </main>
  );
}
